import type { IconType } from 'react-icons'
import {
  IoHomeOutline,
  IoHome,
  IoSearchOutline,
  IoSearch,
  IoHammerOutline,
  IoHammer,
  IoPersonOutline,
  IoPerson,
  IoLockClosedOutline,
  IoLockClosed,
  IoConstructOutline,
  IoConstruct,
  IoInformationCircleOutline,
  IoInformationCircle
} from 'react-icons/io5'
import { GiAmmoBox } from 'react-icons/gi'

export const ICON_BOX = 40
export const ICON_GLYPH = 24

export interface PrimaryNavItem {
  to: string;
  label: string;
  IconActive: IconType;
  IconInactive: IconType;
}

/** Logged-in home / Slop Feed (primary rail "Home"). */
export const PRIMARY_HOME_PATH = '/slop-feed'

/** Primary destinations (bottom bar / sidebar). */
export const PRIMARY_NAV_ITEMS: PrimaryNavItem[] = [
  { to: PRIMARY_HOME_PATH, label: 'Home', IconActive: IoHome, IconInactive: IoHomeOutline },
  { to: '/registry', label: 'Registry', IconActive: IoSearch, IconInactive: IoSearchOutline },
  { to: '/builds', label: 'Builds', IconActive: IoHammer, IconInactive: IoHammerOutline },
  { to: '/profile', label: 'Profile', IconActive: IoPerson, IconInactive: IoPersonOutline },
  {
    to: '/ammo',
    label: 'Ammo',
    IconActive: GiAmmoBox as IconType,
    IconInactive: GiAmmoBox as IconType
  },
  { to: '/vault', label: 'Vault', IconActive: IoLockClosed, IconInactive: IoLockClosedOutline },
  {
    to: '/parts-bin',
    label: 'Parts',
    IconActive: IoConstruct,
    IconInactive: IoConstructOutline
  },
  {
    to: '/about',
    label: 'About',
    IconActive: IoInformationCircle,
    IconInactive: IoInformationCircleOutline
  }
]

/** Whether this primary tab should show as active for the current URL. */
export function isPrimaryNavActive (
  to: string,
  pathname: string,
  username?: string | null
): boolean {
  if (to === PRIMARY_HOME_PATH) {
    return (
      pathname === PRIMARY_HOME_PATH ||
      pathname === '/' ||
      pathname.startsWith(`${PRIMARY_HOME_PATH}/`)
    )
  }
  if (to === '/profile') {
    if (pathname === '/profile') return true
    if (username && pathname === `/profiles/${username}`) return true
    return false
  }
  if (to === '/vault') {
    return pathname === '/vault' || pathname.startsWith('/gun-vault')
  }
  if (to === '/parts-bin') {
    return pathname === '/parts-bin' || pathname.startsWith('/parts/')
  }
  if (to === '/registry' || to === '/builds' || to === '/ammo' || to === '/about') {
    return pathname === to || pathname.startsWith(`${to}/`)
  }
  return pathname === to
}
